import { useState } from 'react';
import Link from 'next/link';
import { PlanWrap, BottomContent } from './Plans.styles';
import { TrendPans } from '../data';

type PlansProps = {
  mWidth?: string;
  readyPlan?: boolean;
  eveningPlan?: boolean;
};

export const Plans = ({ mWidth, readyPlan, eveningPlan }: PlansProps) => {
  return (
    <>
      {readyPlan && (
        <>
          <PlanWrap>
            {TrendPans.readytowear.map((item, index) => (
              <div className={item.topclass} key={index}>
                <div className="content" style={{ maxWidth: mWidth }}>
                  <span className="title_paln">{item.titleplan}</span>
                  <span className="price">
                    <b>Per month:</b> {item.per_month}
                  </span>
                  <span className="price">
                    <b>Per year:</b> {item.per_year}
                  </span>
                  <p dangerouslySetInnerHTML={{ __html: item.description }} />
                  <Link href={`https://api.whatsapp.com/send?phone=+447502816932&text=Hello there,%0a%0aI would like to know more about this plan:%0a%0aMy Name:%0a%0aMy email:%0a%0aIf you wish to contact us, please, use this WhatsApp number also.%0a%0aThank you,%0aBaileys Mansion`}>Go for this Plan</Link>
                </div>
              </div>
            ))}
          </PlanWrap>
          <BottomContent>
            <p>
              *The Plans above are just for Ready-to-Wear tendencies and
              inspiration process.
              <br />
              Please, choose one of the plans that suits you the best and get
              ready to be the star of your dream.
            </p>
          </BottomContent>
        </>
      )}

      {eveningPlan && (
        <>
          <PlanWrap>
            {TrendPans.hautecouture.map((item, index) => (
              <div className={item.topclass} key={index}>
                <div className="content" style={{ maxWidth: mWidth }}>
                  <span className="title_paln">{item.titleplan}</span>
                  <span className="price">
                    <b>Per month:</b> {item.per_month}
                  </span>
                  <span className="price">
                    <b>Per year:</b> {item.per_year}
                  </span>
                  <p dangerouslySetInnerHTML={{ __html: item.description }} />
                  <Link href={`https://api.whatsapp.com/send?phone=+447502816932&text=Hello there,%0a%0aI would like to know more about the Master Plan.%0a0aMy Name:%0a%0aMy email:%0a%0aIf you wish to contact us, please, use this WhatsApp number also.%0a%0aThank you,%0aBaileys Mansion`}>Go for this Plan</Link>
                </div>
              </div>
            ))}
          </PlanWrap>
          <BottomContent>
            <p>
              *The Plan above is just for HIght Fashion - Evening Wear
              tendencies and inspiration process.
              <br />
              Please, choose this plan if suits you and get ready to be the star
              of your dream.
            </p>
          </BottomContent>
        </>
      )}
    </>
  );
};
